<template>
    <div class="cc-note">
      <label for="note">{{ translations['Order note']  }}</label>
      <textarea id="note" class="form-control" name="note" @change="updateNote" :value="value"></textarea>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                value: state => state.orderNote,
            }),
        },
        methods: {
            updateNote: function (e) {
              this.$store.commit('SET_ORDER_NOTE', e.target.value);
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    .cc-note {
        padding: 1rem 1rem 0.5rem 1rem;

        label {
            display: block;
            color: #040404;
            text-align: left;
        }
    }
</style>
